import React from 'react';
import { FaHtml5, FaCss3Alt, FaJs, FaReact, FaMobileAlt, FaNode, FaDatabase, FaShopify, FaRobot, FaCreditCard } from 'react-icons/fa';
import { SiExpress, SiMongodb, SiFirebase, SiOpenai, SiStripe } from 'react-icons/si';
import './Technologies.css';

const Technologies = () => {
  const techCategories = [
    {
      title: 'Frontend',
      icon: <FaReact />,
      technologies: [
        { name: 'HTML5', icon: <FaHtml5 />, color: '#e34c26' },
        { name: 'CSS3', icon: <FaCss3Alt />, color: '#264de4' },
        { name: 'JavaScript (ES6+)', icon: <FaJs />, color: '#f7df1e' },
        { name: 'React JS', icon: <FaReact />, color: '#61dafb' }
      ]
    },
    {
      title: 'Mobile',
      icon: <FaMobileAlt />,
      technologies: [
        { name: 'React Native', icon: <FaReact />, color: '#61dafb' }
      ]
    },
    {
      title: 'Backend',
      icon: <FaNode />,
      technologies: [
        { name: 'Node.js', icon: <FaNode />, color: '#339933' },
        { name: 'Express.js', icon: <SiExpress />, color: '#000000' }
      ]
    },
    {
      title: 'Database',
      icon: <FaDatabase />,
      technologies: [
        { name: 'MongoDB', icon: <SiMongodb />, color: '#47a248' },
        { name: 'Firebase', icon: <SiFirebase />, color: '#ffca28' }
      ]
    },
    {
      title: 'E-Commerce Platforms',
      icon: <FaShopify />,
      technologies: [
        { name: 'Shopify Development', icon: <FaShopify />, color: '#95bf47' }
      ]
    },
    {
      title: 'AI & Automation',
      icon: <FaRobot />,
      technologies: [
        { name: 'OpenAI Integrations', icon: <SiOpenai />, color: '#412991' },
        { name: 'Chatbots', icon: <FaRobot />, color: '#ff6b6b' },
        { name: 'Training ML models', icon: <FaRobot />, color: '#4ecdc4' },
        { name: 'Predictive analytics', icon: <FaRobot />, color: '#45b7d1' },
        { name: 'Workflow automation', icon: <FaRobot />, color: '#f39c12' }
      ]
    },
    {
      title: 'Payment Integrations',
      icon: <FaCreditCard />,
      technologies: [
        { name: 'Razorpay', icon: <FaCreditCard />, color: '#3395ff' },
        { name: 'Stripe', icon: <SiStripe />, color: '#635bff' },
        { name: 'Cashfree', icon: <FaCreditCard />, color: '#00d9ff' },
        { name: 'PhonePe', icon: <FaCreditCard />, color: '#5f259f' },
        { name: 'PayU', icon: <FaCreditCard />, color: '#ff6600' },
        { name: 'Paytm', icon: <FaCreditCard />, color: '#00baf2' }
      ]
    }
  ];

  return (
    <section id="technologies" className="technologies">
      <div className="technologies-container">
        <div className="tech-main-card" data-aos="fade-up">
          {/* Background Tech Elements */}
          <div className="tech-bg-elements">
            <div className="tech-bg-icon tech-bg-1">{<FaReact />}</div>
            <div className="tech-bg-icon tech-bg-2">{<FaNode />}</div>
            <div className="tech-bg-icon tech-bg-3">{<FaDatabase />}</div>
            <div className="tech-bg-icon tech-bg-4">{<FaMobileAlt />}</div>
            <div className="tech-bg-icon tech-bg-5">{<FaJs />}</div>
            <div className="tech-bg-icon tech-bg-6">{<FaShopify />}</div>
            <div className="tech-bg-icon tech-bg-7">{<FaHtml5 />}</div>
            <div className="tech-bg-icon tech-bg-8">{<FaCss3Alt />}</div>
            <div className="tech-bg-icon tech-bg-9">{<FaRobot />}</div>
            <div className="tech-bg-icon tech-bg-10">{<FaCreditCard />}</div>
            <div className="tech-bg-code code-1">{'< />'}</div>
            <div className="tech-bg-code code-2">{'</>'}</div>
            <div className="tech-bg-brackets brackets-1">{'{ }'}</div>
            <div className="tech-bg-brackets brackets-2">{'[ ]'}</div>
            <div className="tech-bg-brackets brackets-3">{'( )'}</div>
            <div className="tech-bg-symbol symbol-1">{'=>'}</div>
            <div className="tech-bg-symbol symbol-2">{'==='}</div>
            <div className="tech-bg-symbol symbol-3">{'&&'}</div>
            <div className="tech-bg-symbol symbol-4">{'||'}</div>
            <div className="tech-bg-symbol symbol-5">{'...'}</div>
          </div>
          
          <div className="tech-card-header" data-aos="fade-up">
            <h2 className="section-title">Technologies We Use</h2>
            <p className="section-subtitle">
              We build using modern, proven, and scalable technologies trusted by startups and enterprises worldwide.
            </p>
          </div>
          
          <div className="tech-card-content">
            <div className="tech-items-flex-wrap">
              {techCategories.map((category, categoryIndex) => (
                category.technologies.map((tech, techIndex) => (
                  <div
                    key={`${categoryIndex}-${techIndex}`}
                    className="tech-badge"
                    data-aos="zoom-in"
                    data-aos-delay={categoryIndex * 30 + techIndex * 20}
                    style={{ '--tech-color': tech.color }}
                  >
                    <div className="tech-badge-icon" style={{ color: tech.color }}>
                      {tech.icon}
                    </div>
                    <span className="tech-badge-name">{tech.name}</span>
                  </div>
                ))
              ))}
            </div>
          </div>
          
          <div className="tech-card-footer" data-aos="fade-up">
            <p className="closing-text">
              Our tech stack ensures speed, security, reliability, and long-term scalability
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Technologies;

